import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/sports/football/match/:matchId?',
    component: () => import('../views/SportFootballMatch.vue')
  },
  {
    path: '/sports/games',
    component: () => import('../views/SportGames.vue')
  },
  {
    path: '/container/monitor',
    component: () => import('../views/Monitor.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
